import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c7e4aca8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }

import dottoriAggiuntiveEdit from './dottoriAggiuntiveEdit.vue'
import dottoriModalConfidenzialita from './dottoriModalConfidenzialita.vue'
import CollapsibleItem from '@/layout/collapsible/CollapsibleItem.vue';
import { CollapsableModel } from '@/../../EshJSLib/models/CollapsableModel';
import { patientStore } from '@/store/patient';
import { storeToRefs } from 'pinia';
import { ref, onMounted, reactive } from 'vue'
import AlertModal from "@/components/AlertModalFeedback.vue";
import schemaCppPaziente from "@/../../EshJSLib/models/form/cppaziente.json";
import schemaCareProviders from "@/../../EshJSLib/models/form/careproviders.json";
import { saveDoctorsAssociated, toggleDoctor, getAscDoctors, getNAdoctors, updateConfidentialitaandVisibilita } from "@/../../EshJSLib/services/cppServices";
import { Careprovider, Associated } from "@/../../EshJSLib/models/patient";
import Mail from "@/components/MailModal.vue";

import { sendEmail } from '@/../../EshJSLib/services/emailServices';
//Ref Element with HTML

export default /*#__PURE__*/_defineComponent({
  __name: 'dottoriPage',
  props: {
  tipo: Number,
},
  setup(__props) {

const props = __props;

const modalAddEditDottori = ref<InstanceType<typeof dottoriAggiuntiveEdit> | null>(null);
const modalConfidenzialita = ref<InstanceType<typeof dottoriModalConfidenzialita> | null>(null);
const modalMail = ref<InstanceType<typeof Mail> | null>(null);
const alertModal = ref<InstanceType<typeof AlertModal> | null>(null);


const iTuoiDottori = ref<InstanceType<typeof CollapsableModel> | null>(null);
const ricercaDottori = ref<InstanceType<typeof CollapsableModel> | null>(null);

// Constant
const store = patientStore();
const { patient } = storeToRefs(store)

const showLoading = ref(false);
const cppModel = reactive({} as Associated);
let alertMessage = ref('');



const originalDoctors = ref([]);

onMounted(async () => {
  //iTuoiDottori.value = { ...schemaCppPaziente } as unknown as  CollapsableModel
  store.fetchAssociatedDoctors();
  store.fetchNotAssociatedDoctors();
  originalDoctors.value = patient.value['avalailable_doctors'];
})

async function saveAndRefreshAssociatedDoctors(userInput: boolean, row: Associated) {
  if (userInput) {
    showLoading.value = true;

    saveDoctorsAssociated(row).then((x) => {
      store.fetchNotAssociatedDoctors();
      store.fetchAssociatedDoctors().then(() => {
        showLoading.value = false;
        alertModal.value.openModal(alertMessage.value, false)
        store.fetchNotAssociatedDoctors();
      })
    }).catch((error) => {
      showLoading.value = false;
      alertModal.value.openModal("Siamo spiacenti si è verificato un errore. La preghiamo di riprovare più tardi", false)

    })
  } else {
    store.fetchAssociatedDoctors();
    store.fetchNotAssociatedDoctors();
  }
}





async function actionAssociated(type: string, row: Associated, index: number, table: string) {
  let mailTemplate = { topic: '', text: '', from: patient.value.paziente_email, to: row.email, name: '', recName: '' };
  switch (type) {
    case "envelope":
      modalMail.value?.openModal("Inviare Mail", mailTemplate).then(input => {
        if (input) {
          sendMail(mailTemplate);
        }
      });
      break;
    case "lock":
      cppModel.assegnazione_confidenzialita = row.assegnazione_confidenzialita;
      cppModel.visibility = row.visibility;
      cppModel.tags = row.tags;
      cppModel.id_cpp = row.id_cpp;
      cppModel.id_paziente = row.id_paziente;
      cppModel.id_careprovider = row.id_careprovider;

      modalAddEditDottori.value.openModal('', cppModel).then(input => {
        if (input) {
          showLoading.value = true;

          updateConfidentialitaandVisibilita(cppModel as Associated).then(() => {
            showLoading.value = false;
            alertModal.value.openModal("Hai aggiornato con successo il livello di confidenzialità!", false)
            store.fetchAssociatedDoctors();
          });


        }
      })
      break;

    case 'trash':
      alertMessage.value = 'Hai rimosso con successo il medico associato!';
      alertModal.value.openModal("Sei sicuro di voler rimuovere il medico?", true).then((userInput) => {
        row.status = 'delete'
        saveAndRefreshAssociatedDoctors(userInput, row)
      })
      break;
  }
}


async function actionCareProviders(type: string, row: Careprovider, index: number, table: string) {
  let userInput = false;
  let newAssociated = {} as Associated;
  switch (type) {
    case 'location-dot':
      alert('to be done');

      break;
    case 'plus':
      alertMessage.value = 'Hai aggiunto un dottore!';
      newAssociated.status = "add";
      newAssociated.assegnazione_confidenzialita = 1
      newAssociated.visibility = 2
      newAssociated.id_careprovider = row.id_cpp
      newAssociated.id_utente_cpp = row.id_utente
      newAssociated.id_utente = patient.value.id_paziente
      newAssociated.id_paziente = patient.value.id_paziente
      saveAndRefreshAssociatedDoctors(true, newAssociated);
      break;
  }
}


function sendMail(mailTemp) {
  const params = JSON.stringify(mailTemp);
  sendEmail(params).then(response => {
    if ('status' in response) {

      if (response.status == 200) {
        alertModal.value.openModal('success', false);
      } else {
        alertModal.value.openModal('fail', false);
      }
    }
  }, error => {
    alertModal.value.openModal('fail', false);
  });
}

async function search(word: string, check: boolean) {
  if (word.trim()) {
    await store.fetchNotAssociatedDoctors();
    patient.value['avalailable_doctors'] = originalDoctors.value.filter((datas) =>
      datas.fullname.toLowerCase().includes(word.toLowerCase())
    );
  } else {
    store.fetchAssociatedDoctors();
    store.fetchNotAssociatedDoctors();
  }
}

return (_ctx: any,_cache: any) => {
  const _component_LoadingComponent = _resolveComponent("LoadingComponent")!

  return (_unref(patient))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(dottoriAggiuntiveEdit, {
          ref_key: "modalAddEditDottori",
          ref: modalAddEditDottori
        }, null, 512),
        _createVNode(dottoriModalConfidenzialita, {
          ref_key: "modalConfidenzialita",
          ref: modalConfidenzialita
        }, null, 512),
        _createVNode(Mail, {
          ref_key: "modalMail",
          ref: modalMail
        }, null, 512),
        _createVNode(CollapsibleItem, {
          data: _unref(schemaCppPaziente),
          onRowActions: _cache[0] || (_cache[0] = (n, r, i) => actionAssociated(n, r, i, 'CppPaziente'))
        }, null, 8, ["data"]),
        _createVNode(CollapsibleItem, {
          data: _unref(schemaCareProviders),
          onRowActions: _cache[1] || (_cache[1] = (n, r, i) => actionCareProviders(n, r, i, 'CareProviders')),
          onSearch: _cache[2] || (_cache[2] = (w, c) => search(w, c))
        }, null, 8, ["data"]),
        _createVNode(AlertModal, {
          ref_key: "alertModal",
          ref: alertModal
        }, null, 512),
        (showLoading.value)
          ? (_openBlock(), _createBlock(_component_LoadingComponent, { key: 0 }))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})